import * as React from 'react';
import classnames from 'classnames';
import { useCartSlots } from '../../../slots/context.js';
import '../../../slots/header-slot/context.js';
import '../../../slots/sidebar-slot/context.js';
import { CartDiscount } from '../components/CartDiscount.js';
import { MainTotal } from '../components/MainTotal.js';
import { PaymentMethodPrice } from '../components/PaymentMethodPrice.js';
import { Shipping } from '../components/Shipping.js';
import '@grandvisionhq/elements';
import { SubscriptionHeader } from '../components/SubscriptionHeader.js';
import { Subtotal } from '../components/Subtotal.js';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import { SubscriptionContainer } from '../containers/SubscriptionContainer.js';

const Mixed = ({ className , currency , labels , lineItems , prices , settings , subscription , hideSubscriptionExplainer  })=>{
    const { Slots  } = useCartSlots();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('cart-totals', className),
        "data-t": "cart-totals"
    }, settings.showSubTotal && /*#__PURE__*/ React.createElement(Subtotal, {
        label: labels.subTotal,
        price: prices.subTotalPrice,
        currency: currency
    }), settings.showTotalDiscount && prices.discountPrice !== 0 && /*#__PURE__*/ React.createElement(CartDiscount, {
        label: labels.totalDiscount,
        price: -prices.discountPrice,
        currency: currency
    }), prices.paymentMethodPrice && /*#__PURE__*/ React.createElement(PaymentMethodPrice, {
        label: labels.paymentMethodPrice,
        price: prices.paymentMethodPrice,
        currency: currency
    }), /*#__PURE__*/ React.createElement(Shipping, {
        labels: labels,
        price: prices.shippingPrice,
        currency: currency
    }), /*#__PURE__*/ React.createElement(MainTotal, {
        label: labels.todaysTotal,
        price: prices.totalPrice,
        currency: currency
    }), Slots.AfterTotals ? /*#__PURE__*/ React.createElement(Slots.AfterTotals, null) : null, /*#__PURE__*/ React.createElement(SubscriptionHeader, {
        header: labels.subscriptionHeader
    }), /*#__PURE__*/ React.createElement(SubscriptionContainer, {
        lineItems: lineItems,
        subscription: subscription,
        hideSubscriptionExplainer: hideSubscriptionExplainer
    }));
};

export { Mixed };
//# sourceMappingURL=Mixed.js.map
